<span [class.bold]="isDescription">{{ label ? (label | translate) + ':' : '' }} {{ value }}</span>
